import { Component, ReactElement, ReactNode } from "react";

import { Button } from "@upstageai/ui";

import { Icon, Icons } from "./components/Icon";

interface Props {
  children: ReactElement | null;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error Boundary caught an error:", error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-4">
          <Icon source={Icons.NoHistory} />
          <div className="flex flex-col items-center justify-center gap-1 p-4 pt-2">
            <div className="h4 text-center">
              There seems to be an error in the system.
            </div>
            <div className="p text-center">
              Please try again in a few minutes.
            </div>
          </div>
          <Button onClick={() => window.location.reload()}>Refresh</Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
